
import React, { useContext } from 'react';
import AppContext from '../context/app/appContext';
import FilterTag from './FilterTag';
import FilterLocations from './FilterLocations';
import FilterTime from './FilterTime';

import 'react-perfect-scrollbar/dist/css/styles.css';


const LeftMenu = (props) => {

  const appContext = useContext(AppContext);

  var showStates = false;
  if (appContext.activeOptions['cot'] && appContext.activeOptions['cot'].indexOf("1") >= 0) { // usa
    showStates = true;
  } else if (appContext.activeOptions['st'] && appContext.activeOptions['st'].length) {
    appContext.unsetSelectedOptions('st'); // remove selected states
  }

  return (
    <div className="sidebar">
      {appContext.dictionaries &&
        <ul id="app-menu" className="sidebar-nav">
          <FilterTag ident="gt" title="Genres" />
          <FilterTag ident="tt" title="Themes" />
          <FilterTag ident="lt" title="Labels" />
          <FilterTag ident="f" title="Formats" />
          <FilterTag ident="pt" title="People" />
          <FilterTag ident="ft" title="Special Formats" />
          <FilterTag ident="c" title="Cities" />
          <FilterTag ident="cot" title="Countries" />
          {
            showStates &&
            <FilterTag ident="st" title="States" />
          }

          <FilterLocations ident="locations" />
          <FilterTime ident="time" />
        </ul>
      }
    </div>
  );
}

export default LeftMenu;